// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_Hpl","cls2":"ExportFormatModal-cls2_Dzz ExportFormatModal-cls1_Hpl"};